var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXsvg3X({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4969 15.0078L22.1595 9.58789H21.0546L17.0061 14.2939L13.7725 9.58789H10.043L14.9328 16.7043L10.043 22.3879H11.1479L15.4233 17.4181L18.8382 22.3879H22.5677L17.4966 15.0078H17.4969ZM15.9835 16.767L15.4881 16.0583L11.5461 10.4197H13.2432L16.4245 14.9703L16.9199 15.6789L21.0552 21.5939H19.358L15.9835 16.7672V16.767Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXsvg3X);
export default __webpack_public_path__ + "static/media/XSVG3X.bfa2dc583d3b88e122f236d7fba806b4.svg";
export { ForwardRef as ReactComponent };